/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import  LoginPage  from '../pages/public/LoginPage'; 
import DashboardPage from '../pages/guarded/DashboardPage';

const MainGuardRoute = () => {
    let auth = true; 
    return auth ? <DashboardPage /> : <LoginPage />;
}
export default MainGuardRoute;